// extracted by mini-css-extract-plugin
export var body = "_e5-0";
export var sectionHeader = "_e5-4";
export var shortcutColumns = "_e5-2";
export var shortcutList = "_e5-1";
export var shortcutSection = "_e5-3";